<template>
    <div>

        <PageHeader>
            {{ $t('yourTipboxLink') }}
            <template #side>
                <div class="d-none d-md-flex flex-wrap gap-3">
                    <ButtonIcon
                        v-if="landingPage"
                        :href="profileUrl"
                        target="_blank"
                        variant="success"
                        icon="external-link"
                        flip-icon
                        :disabled="busy"
                    >
                        {{ $t('seeYourProfile') }}
                    </ButtonIcon>
                    <ButtonIcon :to="parentRoute">
                        {{ $t('goBack') }}
                    </ButtonIcon>
                </div>
            </template>
            <template #bottom>
                <div class="d-md-none d-flex flex-wrap gap-3 mb-3">
                    <ButtonIcon
                        v-if="landingPage"
                        :href="profileUrl"
                        target="_blank"
                        variant="success"
                        icon="external-link"
                        flip-icon
                        :disabled="busy"
                    >
                        {{ $t('seeYourProfile') }}
                    </ButtonIcon>
                    <ButtonIcon :to="parentRoute">
                        {{ $t('goBack') }}
                    </ButtonIcon>
                </div>

                <b-button href="https://getbuybox.com/ustawienia-twojego-profilu-tipbox-link/" target="_blank" variant="link" class="d-flex align-items-center p-0 mr-4">
                    <feather type="file-text" class="mr-2" /> {{ $t('seeHowToUseTipboxLink') }}
                </b-button>
            </template>
        </PageHeader>

        <Card :header="$t('settingsYourProfile')" :sub-header="$t('settingsYourProfileDescription')" class="mb-0 shadow-none" overlay :loading="loading">
            <div class="row gx-4 gy-4">
                <div class="col-12 col-md-6">

                    <FormValidator id="form-group-profile-name" :validator="$v.form.profileName" v-slot="slotProps" form-group :label="$t('profileName')">
                        <b-form-input id="form-profile-name" v-model="form.profileName" :state="slotProps.state" :disabled="busy" />
                    </FormValidator>

                    <FormValidator id="form-group-description" :validator="$v.form.description" :msg-props="{ max: $v.form.description.$params.maxLength.max }" form-group>
                        <template #label>
                            <div class="d-flex align-items-center">
                                <div>{{ $t('profileDescription') }}</div>
                                <div class="ml-auto text-secondary font-weight-normal">{{ form.description.length }}/{{ $v.form.description.$params.maxLength.max }}</div>
                            </div>
                        </template>
                        <template #default="slotProps">
                            <b-form-textarea
                                id="form-description"
                                v-model="form.description"
                                :state="slotProps.state"
                                class=""
                                :disabled="busy"
                                rows="4"
                            />
                        </template>
                    </FormValidator>

                    <FormValidator id="form-group-thanks" :validator="$v.form.thanks" :msg-props="{ max: $v.form.thanks.$params.maxLength.max }" form-group>
                        <template #label>
                            <div class="d-flex align-items-center">
                                <div>{{ $t('contentOfThanks') }}</div>
                                <div class="ml-auto text-secondary font-weight-normal">{{ form.thanks.length }}/{{ $v.form.thanks.$params.maxLength.max }}</div>
                            </div>
                        </template>
                        <template #default="slotProps">
                            <b-form-textarea
                                id="form-thanks"
                                v-model="form.thanks"
                                :state="slotProps.state"
                                class=""
                                :disabled="busy"
                                rows="4"
                            />
                        </template>
                    </FormValidator>

                    <b-form-group id="form-group-amounts" :label="$t('amounts')">
                        <div class="d-flex flex-wrap gap-2">
                            <FormValidator id="form-group-amounts-0" :validator="$v.form.amounts[0]" :msg-props="{ min: amounts.min[0], max: amounts.max[0] }" v-slot="slotProps" class="flex-grow-1 flex-basis-0 width-min-50 width-max-200">
                                <b-form-input id="form-amounts-0" v-model="form.amounts[0]" :state="slotProps.state" :disabled="busy" placeholder="5" />
                            </FormValidator>
                            <FormValidator id="form-group-amounts-1" :validator="$v.form.amounts[1]" :msg-props="{ min: amounts.min[1], max: amounts.max[1] }" v-slot="slotProps" class="flex-grow-1 flex-basis-0 width-min-50 width-max-200">
                                <b-form-input id="form-amounts-1" v-model="form.amounts[1]" :state="slotProps.state" :disabled="busy" placeholder="10" />
                            </FormValidator>
                            <FormValidator id="form-group-amounts-2" :validator="$v.form.amounts[2]" :msg-props="{ min: amounts.min[2], max: amounts.max[2] }" v-slot="slotProps" class="flex-grow-1 flex-basis-0 width-min-50 width-max-200">
                                <b-form-input id="form-amounts-2" v-model="form.amounts[2]" :state="slotProps.state" :disabled="busy" placeholder="15" />
                            </FormValidator>
                        </div>
                    </b-form-group>

                    <b-form-group id="form-group-links" :label="$t('yourLinks')">
                        <div class="d-flex flex-column gap-3">
                            <div v-for="(item, index) in form.links" :key="index" class="d-flex gap-3">
                                <FormValidator :id="`form-group-links-${index}-url`" class="d-flex flex-column flex-grow-2 flex-shrink-0 flex-basis-0" :validator="$v.form[`links-${index}-url`]" v-slot="slotProps">
                                    <b-form-input :id="`form-links-${index}-url`" v-model="form.links[index].url" :placeholder="$t('urlAddress')" :disabled="busy" :state="slotProps.state" />
                                </FormValidator>
                                <FormValidator :id="`form-group-links-${index}-social`" class="d-flex flex-column flex-grow-1 flex-shrink-0 flex-basis-0" :validator="$v.form[`links-${index}-social`]" v-slot="slotProps">
                                    <b-form-select
                                        :id="`form-links-${index}-social`"
                                        v-model="form.links[index].social"
                                        :placeholder="$t('kind')"
                                        :disabled="busy"
                                        :state="slotProps.state"
                                        :options="socials"
                                        text-field="label"
                                        value-field="value"
                                    />
                                </FormValidator>
                                <ButtonIcon
                                    :disabled="busy"
                                    variant="danger"
                                    icon="trash-2"
                                    :title="$t('remove')"
                                    class="mb-auto"
                                    @click="removeLink(index)"
                                />
                            </div>
                            <ButtonIcon :disabled="busy" class="wide mr-auto" variant="outline-success" @click="addLink()">
                                {{ $t('addAnotherLink') }}
                            </ButtonIcon>
                        </div>
                    </b-form-group>

                </div>
                <div class="col-12 col-md-6">

                    <FormValidator id="form-group-slug" :validator="$v.form.slug" v-slot="slotProps" form-group :label="$t('linkToProfile')">
                        <b-input-group prepend="tipbox.link/">
                            <b-form-input id="form-slug" v-model="form.slug" :state="slotProps.state" :disabled="busy" :placeholder="$t('tipboxSlugPlaceholder')" />
                        </b-input-group>
                    </FormValidator>

                    <FormValidator
                        id="form-group-avatar"
                        class="d-flex flex-column flex-grow-1"
                        :validator="$v.formAvatar.avatar"
                        form-group
                        :label="$t('avatar')"
                        v-slot="slotProps"
                        :msg-props="{ max: $v.formAvatar.avatar.$params.fileSizeMax.max }"
                        :description="`${$t('supportedFormatsX', { formats: 'APNG, AVIF, GIF, JPEG, PNG, SVG, WEBP' })} ${$t('maximumFileSizeX', { size: $v.formAvatar.avatar.$params.fileSizeMax.max })}`"
                    >
                        <div class="d-flex gap-2">
                            <FormFile
                                id="form-avatar"
                                v-model="formAvatar.avatar"
                                accept="image/*"
                                show-thumbnails
                                :state="slotProps.state"
                                :disabled="busy"
                                :loading="requestTipboxLandingPageAvatar.getLoading()"
                            />
                            <b-modal
                                v-if="landingPage"
                                ref="formAvatarModal"
                                centered
                                hide-footer
                                hide-header
                                body-class="text-center d-flex justify-content-center align-items-center height-min-200"
                            >
                                <ImageLoader v-if="landingPage" :src="landingPage.avatar" image-class="w-auto" error-class="w-auto" style="max-width: 100%;" />
                            </b-modal>
                            <ImageLoader
                                v-if="landingPage"
                                :src="landingPage.avatar"
                                class="my-auto cursor-pointer"
                                height="40px"
                                width="40px"
                                @click.native="$refs.formAvatarModal.show()"
                            />
                        </div>
                    </FormValidator>

                    <b-form-group id="form-group-color" :label="$t('color')">
                        <ColorField
                            id="form-color"
                            v-model="form.color"
                            placeholder="#000000"
                            :disabled="busy"
                            class="mb-0"
                        />
                    </b-form-group>

                    <div class="d-flex flex-column">
                        <div class="d-flex flex-wrap gap-2">

                            <FormValidator
                                id="form-group-icon"
                                :validator="$v.form.icon"
                                v-slot="slotProps"
                                form-group
                                :label="$t('icon')"
                                class="flex-grow-1"
                            >
                                <b-form-select
                                    id="form-icon"
                                    v-model="form.icon"
                                    :options="optionsIcons"
                                    text-field="label"
                                    class="flex-grow-1"
                                    :placeholder="$t('select')"
                                    add-null-option
                                    :state="slotProps.state"
                                    :disabled="busy"
                                />
                            </FormValidator>

                            <FormValidator
                                id="form-group-icon-version"
                                :validator="$v.form.iconVersion"
                                v-slot="slotProps"
                                form-group
                                :label="$t('kind')"
                                class="flex-grow-1"
                            >
                                <b-form-select
                                    id="form-icon-version"
                                    v-model="form.iconVersion"
                                    :options="optionsIconVersions"
                                    text-field="label"
                                    class="flex-grow-1"
                                    :placeholder="$t('select')"
                                    add-null-option
                                    :state="slotProps.state"
                                    :disabled="busy || !form.icon"
                                />
                            </FormValidator>

                            <b-form-group class="width-40 flex-shrink-0 mt-auto">
                                <ImageLoader v-if="form.icon && form.iconVersion" :src="getIconPath()" :size="40" />
                            </b-form-group>

                        </div>
                    </div>

                    <FormValidator id="form-group-ga-id" :validator="$v.form.gaId" v-slot="slotProps" form-group :label="$t('googleAnalyticsOptional')">
                        <b-form-input id="form-ga-id" v-model="form.gaId" :state="slotProps.state" :disabled="busy" placeholder="G-XXXXXXXXXX" />
                    </FormValidator>

                    <FormValidator id="form-group-source-url" :label="$t('webhookUrlOptional')" :validator="$v.formSpace.webhook" v-slot="slotProps" form-group>
                        <div class="d-flex gap-3">
                            <b-form-input
                                id="form-icon-version"
                                v-model="formSpace.webhook"
                                :state="slotProps.state"
                                placeholder="https://"
                                class=""
                                :disabled="busy"
                            />
                            <div class="width-40 flex-shrink-0"></div>
                        </div>
                    </FormValidator>

                </div>
            </div>


            <div class="d-flex gap-3 mt-5">
                <ButtonIcon :loading="saving" :disabled="busy" class="wide" @click="formSubmit()">
                    {{ $t('save') }}
                </ButtonIcon>
                <ButtonIcon
                    v-if="landingPage"
                    :href="profileUrl"
                    target="_blank"
                    variant="success"
                    icon="external-link"
                    flip-icon
                    :disabled="busy"
                >
                    {{ $t('seeYourProfile') }}
                </ButtonIcon>
            </div>

        </Card>

    </div>
</template>



<script>
    import { serialize as objectToFormData } from 'object-to-formdata';
    import cloneDeep from 'lodash/cloneDeep';
    import { required, requiredIf, decimal, minValue, maxValue, helpers, maxLength } from 'vuelidate/lib/validators';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';
    import { image, url, fileSize } from '@/utils/validators';
    import FormValidator from '@/components/common/FormValidator.vue';
    import FormFile from '@/components/common/FormFile.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import ColorField from '@/components/common/ColorField.vue';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';

    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

    const FORM_DEFAULT_DATA = Object.freeze({
        amounts: [null, null, null],
        profileName: '',
        description: '',
        thanks: '',
        slug: '',
        color: '',
        icon: null,
        iconVersion: null,
        links: [{ url: '', social: '' }],
        gaId: '',
    });

    const FORM_AVATAR_DEFAULT_DATA = Object.freeze({
        avatar: null,
    });

    const FORM_SPACE_DEFAULT_DATA = Object.freeze({
        webhook: null,
    });

    export default {
        name: 'TipboxLinkEdit',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
            FormFile,
            ImageLoader,
            ColorField,
        },
        data() {
            return {
                requestTipboxLandingPage: this.$req('tipbox/TipboxLandingPage'),
                requestTipboxLandingPageAvatar: this.$req('tipbox/TipboxLandingPageAvatar'),
                requestIcons: this.$req('tipbox/Icons'),
                requestIconVersions: this.$req('tipbox/IconVersions'),
                requestAvailableSocials: this.$req('tipbox/AvailableSocials'),
                requestSpace: this.$req('space/space'),
                spaceId: Number.parseInt(this.$route.params.id),
                form: cloneDeep(FORM_DEFAULT_DATA),
                formAvatar: cloneDeep(FORM_AVATAR_DEFAULT_DATA),
                formSpace: cloneDeep(FORM_SPACE_DEFAULT_DATA),
                landingPage: null,
            };
        },
        computed: {
            formValidations() {
                return {
                    form: {
                        amounts: {
                            0: { required, decimal, minValue: minValue(this.amounts.min[0]), maxValue: maxValue(this.amounts.max[0]) },
                            1: { required, decimal, minValue: minValue(this.amounts.min[1]), maxValue: maxValue(this.amounts.max[1]) },
                            2: { required, decimal, minValue: minValue(this.amounts.min[2]), maxValue: maxValue(this.amounts.max[2]) },
                        },
                        profileName: { required, maxLength: maxLength(50) },
                        description: { maxLength: maxLength(300) },
                        thanks: { maxLength: maxLength(300) },
                        slug: { required, maxLength: maxLength(50), regex: value => (!value ? true : slugRegex.test(value)) },
                        gaId: { maxLength: maxLength(50) },
                        ...this.form.links.reduce(
                            (acc, item, index) => ({
                                ...acc,
                                ...{
                                    [`links-${index}-social`]: {
                                        required: () => (item.url ? required(item.social) : true),
                                    },
                                    [`links-${index}-url`]: {
                                        required: () => (item.social ? required(item.url) : true),
                                        url: () => (item.url ? url(item.url) : true),
                                    },
                                },
                            }),
                            {}
                        ),
                        icon: {},
                        iconVersion: { required: requiredIf(form => form.icon) },
                        webhook: { url: val => !val || url(val) },
                    },
                    formAvatar: {
                        avatar: { image: value => !helpers.req(value) || image(value), fileSizeMax: fileSize({ max: '1MB' }) },
                    },
                    formSpace: {
                        webhook: { url: val => !val || url(val) },
                    },
                };
            },
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-2)[0];
            },
            profileUrl() {
                if (!this.landingPage?.slug) return '';
                const baseUrl = process.env.VUE_APP_TIPBOX_LANDING_PREVIEW_URL.replace(/\/+$/, '');
                return `${baseUrl}/${this.landingPage.slug}`;
            },
            amounts() {
                const min = 5;
                const max = 1500;
                const step = 0.5;
                const amounts = this.form.amounts;
                const indexes = [0, 1, 2];
                const calculateMin = index => (index === 0 ? min : Math.min(max, (Number.parseInt(amounts[index - 1]) || min) + step));
                const calculateMax = index => max - (indexes.length - index - 1) * step;
                const minValues = Object.fromEntries(indexes.map(index => [index, calculateMin(index)]));
                const maxValues = Object.fromEntries(indexes.map(index => [index, calculateMax(index)]));
                return { min: minValues, max: maxValues };
            },
            loading() {
                return this.requestTipboxLandingPage.getLoading();
            },
            saving() {
                return this.requestTipboxLandingPage.getLoading('patch') || this.requestTipboxLandingPage.getLoading('post');
            },
            error() {
                return this.requestTipboxLandingPage.getError();
            },
            busy() {
                return this.requestTipboxLandingPage.getAnyLoading() || this.requestSpace.getLoading();
            },
            socials() {
                return this.requestAvailableSocials.getData() || [];
            },
            optionsIcons() {
                return (this.requestIcons.getData() || []).sort((a, b) => a.label > b.label);
            },
            optionsIconVersions() {
                return this.requestIconVersions.getData() || [];
            },
        },
        watch: {
            'form.icon': {
                handler(icon, prevIcon) {
                    if (!icon) {
                        this.form.iconVersion = null;
                    } else if (!prevIcon) {
                        this.form.iconVersion = 'colorful';
                    }
                },
            },
            'formAvatar.avatar': {
                handler(avatar) {
                    if (avatar) this.$v.formAvatar.avatar.$touch();
                },
            },
            'formSpace.webhook': {
                handler(webhook) {
                    if (webhook) this.$v.formSpace.webhook.$touch();
                },
            },
        },
        methods: {
            initFormData() {
                const form = deepMergeWithFilter(FORM_DEFAULT_DATA, this.landingPage);
                this.form = form;
            },
            initFormAvatarData() {
                this.formAvatar = deepMergeWithFilter(FORM_AVATAR_DEFAULT_DATA, {});
            },
            initFormSpaceData() {
                this.formSpace = deepMergeWithFilter(FORM_SPACE_DEFAULT_DATA, this.requestSpace.getData() || {});
            },
            fetchTipboxLandingPage() {
                return this.requestTipboxLandingPage
                    .get({ urlParams: { spaceId: this.spaceId } })
                    .then(data => {
                        this.landingPage = { ...this.landingPage, ...data };
                        this.initFormData();
                    })
                    .catch(() => {});
            },
            getIconPath() {
                return require(`@/assets/ikonki_tipbox/${this.form.icon}/${this.form.iconVersion}.svg`); // eslint-disable-line
            },
            fetchIcons() {
                return this.requestIcons.get().catch(() => {});
            },
            fetchIconVersions() {
                return this.requestIconVersions.get().catch(() => {});
            },
            fetchAvailableSocials() {
                return this.requestAvailableSocials.get().catch(() => {});
            },
            fetchSpace() {
                return this.requestSpace
                    .get(this.spaceId)
                    .then(this.initFormSpaceData)
                    .catch(() => {});
            },
            async formSubmit() {
                this.$v.form.$touch();
                this.$v.formAvatar.$touch();
                this.$v.formSpace.$touch();
                if (this.$v.form.$invalid || this.$v.formAvatar.$invalid || this.$v.formSpace.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                await this.saveForm();
                await this.saveAvatar();
                await this.saveSpace();
            },
            saveForm() {
                const apiParams = {
                    urlParams: { spaceId: this.spaceId },
                    requestParams: {
                        ...this.form,
                        links: this.form.links.filter(({ url, social }) => url && social), // eslint-disable-line
                    },
                };
                const type = this.landingPage ? 'patch' : 'post';
                return this.requestTipboxLandingPage
                    .id(type)
                    [type](apiParams)
                    .then(data => {
                        this.landingPage = { ...this.landingPage, ...this.form, ...data };
                        this.initFormData();
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$v.form.$reset();
                    })
                    .catch(this.handleBackendValidations);
            },
            saveAvatar() {
                if (!this.formAvatar.avatar) {
                    return Promise.resolve();
                }
                const apiParams = {
                    urlParams: { spaceId: this.spaceId },
                    requestParams: objectToFormData(this.formAvatar),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                return this.requestTipboxLandingPageAvatar
                    .post(apiParams)
                    .then(({ avatar }) => {
                        if (avatar) this.$set(this.landingPage, 'avatar', avatar);
                        this.initFormAvatarData();
                        this.$v.formAvatar.$reset();
                    })
                    .catch(error => {
                        if (error.messages.length) {
                            this.$toastr.error(error.messages, error.message);
                        } else {
                            this.$toastr.error(error.message, this.$t('errorOccurred'));
                        }
                    });
            },
            saveSpace() {
                return this.requestSpace
                    .patch(this.spaceId, { webhook: this.formSpace.webhook })
                    .then(({ webhook }) => {
                        // if (webhook) this.$set(this.landingPage, 'webhook', webhook);
                        this.initFormSpaceData();
                        this.$v.formSpace.$reset();
                    })
                    .catch(error => {
                        if (error.messages.length) {
                            this.$toastr.error(error.messages, error.message);
                        } else {
                            this.$toastr.error(error.message, this.$t('errorOccurred'));
                        }
                    });
            },
            addLink() {
                this.form.links.push({ url: '', social: '' });
            },
            removeLink(index) {
                this.form.links.splice(index, 1);
            },
        },
        created() {
            this.fetchTipboxLandingPage();
            this.fetchIcons();
            this.fetchIconVersions();
            this.fetchAvailableSocials();
            this.fetchSpace();
        },
    };
</script>
